export default __webpack_public_path__ + "static/media/2.cd2035c4.PNG";